import { Injectable } from '@angular/core';
import { Http,Response , Headers } from '@angular/http';
import { Config } from '../../../config/config';
import { VnptHttpService } from '../../services/vnpt-http.service';
import { Observable }     from 'rxjs/Observable';
import { DMDongTBComponent } from './dm-dong-thiet-bi.component';
import { DMDongTB } from './dm-dong-thiet-bi';
import { AuthService } from '../../services/auth.service';
@Injectable()
export class DMDongTBService {

    controller:string = 'DM_DongThietBi';
    constructor(private http: Http) { }

    GetList_all(idhangsanxuat: number, idloaithietbi: number) {
    let headers = new Headers();
    let data = {IdHangSanXuat:idhangsanxuat, IdLoaiThietBi:idloaithietbi};
    headers.append("Content-Type", "application/json;charset=utf-8");        
    headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
    return this.http.post(Config.apiUrl +this.controller+ "/GetList_all", JSON.stringify(data),{ headers: headers }).map(resp => resp.json());       
    }    
    GetList(paging:number,maxSize:number, keyword: string, idhangsanxuat: number, idloaithietbi: number) {
        let headers = new Headers();
        let currentPage = paging - 1;
        let data = {currentPage: currentPage, maxSize:maxSize, keyword:keyword, IdHangSanXuat:idhangsanxuat, IdLoaiThietBi:idloaithietbi};
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.post(Config.apiUrl +this.controller+ "/GetList", JSON.stringify(data),{ headers: headers }).map(resp => resp.json());       
    }
    GetListSort(idhangsanxuat: number, idloaithietbi: number) {
        let headers = new Headers();
        let data = {IdHangSanXuat: idhangsanxuat, IdLoaiThietBi: idloaithietbi};
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.post(Config.apiUrl +this.controller+ "/GetListSort", JSON.stringify(data),{ headers: headers }).map(resp => resp.json());       
    }
    Save(item:DMDongTB) {  
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = item;
        return this.http.post(Config.apiUrl + this.controller+'/save', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/thiet-bi/dm-dong-thiet-bi/dm-dong-thiet-bi.service.ts